<h2 mat-dialog-title>{{ data.title ?? 'Create client account' }}</h2>

<mat-dialog-content>
  <div class="entity-form">
    <mat-form-field>
      <mat-label> Client Code </mat-label>
      <input matInput [formField]="form.ClientCode" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Client Name </mat-label>
      <input matInput [formField]="form.ClientName" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Xero ID </mat-label>
      <input matInput [formField]="form.XeroId" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Insightly ID </mat-label>
      <input matInput [formField]="form.InsightlyId" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> AWS ID </mat-label>
      <input matInput [formField]="form.AwsId" />
    </mat-form-field>

    <mat-checkbox [formField]="form.Commissionable"> Commissionable </mat-checkbox>

    <mat-form-field>
      <mat-label> Notes </mat-label>
      <textarea matInput [formField]="form.Notes"></textarea>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matMiniFab matTooltip="Save client details" (click)="save()" [disabled]="!form().valid() || pending()">
    <mat-icon>save</mat-icon>
  </button>
</mat-dialog-actions>
@if (pending()) {
  <mat-progress-bar mode="indeterminate" />
}
